export default "__VITE_ASSET__BWqy2M3a__"